import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import * as Yup from 'yup'

import { useFormik } from 'formik'
import { ApplicationState } from '@/state/root.models'
import { Excluded } from '@/state/excluded-games/models'

import { useExcludedGamesActions } from './use-excluded-games-actions.hook'
import { setSnackbarAction } from '../../../../state/ui/global/slices/index.slices'
import { useAppDispatch } from '../../../../state'

export const useExcludedGamesForm = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const { excludedGames, currentGame, gamesList } = useSelector(
    ({ excludedGames }: ApplicationState) => excludedGames,
  )
  const { saveExcludedGames, setCurrentGame } = useExcludedGamesActions()

  const handleSaveExcludedGame = () => {
    const updatedGame: Excluded = {
      gameId: formikGame.values.game.id,
      gameProviderId: formikGame.values.game.vendorExternalID,
      gameDescription: formikGame.values.game.name,
      isBlocked: formikGame.values.isBlocked,
    }

    if (!currentGame) {
      const isDuplicate = excludedGames.games?.some(
        (game) =>
          Number(game.gameId) === Number(updatedGame.gameId) &&
          Number(game.gameProviderId) === Number(updatedGame.gameProviderId),
      )
      if (isDuplicate) {
        dispatch(
          setSnackbarAction({
            open: true,
            variant: 'warning',
            message: t('messages.gameAlreadyAdded'),
          }),
        )
        return
      }
    }

    let savedExcludedGameList: Excluded[] = []

    if (currentGame) {
      savedExcludedGameList = excludedGames.games.map((game: Excluded) =>
        game.gameId === currentGame.gameId &&
        game.gameProviderId === currentGame.gameProviderId
          ? updatedGame
          : game,
      )
    } else {
      savedExcludedGameList = [...(excludedGames.games ?? []), updatedGame]
    }

    saveExcludedGames({
      _id: excludedGames._id,
      name: 'Default Excluded Games',
      games: savedExcludedGameList,
    })

    setCurrentGame()
    formikGame.resetForm()
  }

  // Form Excluded Games
  const initialValuesGame = {
    game: {
      id: currentGame?.gameId,
      gameProviderId: currentGame?.vendorExternalID,
      vendorExternalID: currentGame?.vendorExternalID,
      name: currentGame?.gameDescription,
    },
    isBlocked: currentGame?.isBlocked || false,
  }

  const validationSchemaGame = Yup.object().shape({
    game: Yup.object().nullable(false).required(t('error.requiredField')),
  })

  const formikGame = useFormik({
    initialValues: initialValuesGame,
    validationSchema: validationSchemaGame,
    onSubmit: () => {},
    enableReinitialize: true,
  })

  return {
    handleSaveExcludedGame,
    excludedGames,
    formikGame,
    currentGame,
    gamesList,
  }
}
